import { render, staticRenderFns } from "./Parallax.vue?vue&type=template&id=452f9234&"
import script from "./Parallax.vue?vue&type=script&async=true&lang=js&"
export * from "./Parallax.vue?vue&type=script&async=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports